<template>
    <div class="social-share-block margin-both-lg" v-if="currentPage">
        <SocilaSharing
            :url="fixPageLink"
            :title="currentPage.title"
            :description="currentPage.excerpt"
            inline-template
        >
            <div class="sharing-icons jost jost--22 font--600">
                <network class="item fb" network="facebook">
                    <component :is="$parent.buttonPass" type="dark">
                        <span class="text">Del på Facebook</span>
                        <svg class="icon-share" width="13px" height="25px" viewBox="0 0 13 25" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <title>Background</title> <defs> <path d="M10.46875,4.15104167 L12.7510417,4.15104167 L12.7510417,0.176041667 C12.3572917,0.121875 11.003125,0 9.42604167,0 C6.13541667,0 3.88125,2.06979167 3.88125,5.87395833 L3.88125,9.375 L0.25,9.375 L0.25,13.81875 L3.88125,13.81875 L3.88125,25 L8.33333333,25 L8.33333333,13.8197917 L11.8177083,13.8197917 L12.3708333,9.37604167 L8.33229167,9.37604167 L8.33229167,6.31458333 C8.33333333,5.03020833 8.67916667,4.15104167 10.46875,4.15104167 L10.46875,4.15104167 Z" id="path-1"></path> </defs> <g id="Elements" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="Icons/Social-Media/Facebook" transform="translate(-6.000000, 0.000000)"> <g id="Color/Dark-blue" transform="translate(6.000000, 0.000000)"> <mask id="mask-2" fill="white"> <use xlink:href="#path-1"></use> </mask> <use id="Mask" fill="#000000" fill-rule="nonzero" xlink:href="#path-1"></use> <g mask="url(#mask-2)" fill="#143D54" id="Rectangle"> <g transform="translate(-6.000000, 0.000000)"> <rect x="0" y="0" width="25" height="25"></rect> </g> </g> </g> </g> </g> </svg>
                    </component>
                </network>
                <network class="item email" network="email">
                    <component :is="$parent.buttonPass" type="dark">
                        <span class="text">Tips en venn</span>
                        <svg class="icon-share" width="10" height="8" viewBox="0 0 10 8" xmlns="http://www.w3.org/2000/svg"><defs/><g fill="#485157"><path d="M9.66.307H.34A.34.34 0 000 .648v6.648c0 .188.153.34.34.34h9.32a.34.34 0 00.34-.34V.648a.34.34 0 00-.34-.34zm-.342 6.648H.682V.989h8.636v5.966z"/><path d="M9.453.377L5 3.765.547.377.134.919l4.66 3.546a.34.34 0 00.412 0L9.866.919 9.453.377z"/></g></svg>
                    </component>
                </network>
            </div>
        </SocilaSharing>
    </div>
</template>

<script>
// https://www.npmjs.com/package/vue-social-sharing
import SocilaSharing from 'vue-social-sharing';
import { mapGetters } from 'vuex';
import FancyBtn from '@/components/elements/Button'
import { trimLink } from '@/helpers'

export default {
    name: 'share-links',
    data(){
        return {
        }
    },
    mounted(){
    },
    components:{
        SocilaSharing,
        FancyBtn
    },
    computed:{
        ...mapGetters([
            'currentPage'
        ]),
        fixPageLink(){
            let link = this.currentPage.link
            if(!link) return
            const home = window.WPVUE.home;

            if(!link.includes(home)){
                link = trimLink(home) + link
            }
            return link
        },
        buttonPass(){
            return FancyBtn
        }
    },
    methods:{
        printMe(){
            window.print()
        }
    }
    
};
</script>


<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";
.social-share-block{
    display: flex;
    align-items: center;
    font-weight: bold;
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;
    .sharing-icons{
        display: flex;
        margin-left: auto;
        margin-right: auto;
        @include mquery($phone){
            display: block;
            .item{
                margin-bottom: 8px;
                margin-right: 0!important;
            }
        }
        .item{
            margin-right: 15px;
            svg.icon-share{
                display: block;
                width: 25px;
                height: 25px;
                margin-left: 15px;
                path{
                    transition: fill 0.2s ease-in-out;
                    fill: #fff;
                }  
            }
            &.fb{
                svg.icon-share{
                    rect{
                        fill: #fff
                    }
                }
            }
            &:hover{
                svg.icon-share{
                    path{
                        transition: fill 0.2s ease-in-out;
                        fill: $dark;
                    }
                }
            }
           
        }
    }
}
</style>